import React from 'react';
import { useSelector } from 'react-redux';
import { userRoleDescriptor } from 'models';
import { useTranslation } from 'react-i18next';
import FormQueryObjectTable from 'mrf/view/FormQueryObjectTable';
import PropTypes from 'prop-types';

export default function UserRoleView({ userId }) {
    const { t } = useTranslation();
    const user = useSelector(state => state?.resources?.users?.byId?.[userId]);

    const fields = [
        { name: 'Role', keys: ['role', 'name'], map: t },
    ];

    const formMap = roleId => ({
        userId: userId,
        roleId: roleId,
    });

    const confirmDelete = role => {
        return window.confirm(t(
            'Do you really want to remove role "{{role}}" from user "{{user}}"?',
            { role: role?.name, user: user?.email }
        ));
    }

    return (
        <FormQueryObjectTable
            ownerId={userId}
            endpoint='/api/users/roles' // FIXME: [CDI-444] Filter already selected User Roles
            relationshipDescriptor={userRoleDescriptor}
            field='roleId'

            tableLabel='User Roles'
            tableResource='userRoles'
            tableFields={fields}

            modalTitle='Add Role'
            modalResource='roles'
            modalDisplayAttributeName='name'

            formMap={formMap}
            confirmDelete={confirmDelete}

            hideSearchField
            useSectionTitle

            selectEventMapper={e => e.target.value === '' ? null : e.target.value}
        />
    )
}

UserRoleView.propTypes = {
    userId: PropTypes.string.isRequired,
};
